import _e from "react";
import { g as Te } from "./plotly-vendor-Xl9RTeYD.js";
var be = {}, ae = { exports: {} }, Z = { exports: {} }, E = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fe;
function Pe() {
  if (fe) return E;
  fe = 1;
  var i = typeof Symbol == "function" && Symbol.for, $ = i ? Symbol.for("react.element") : 60103, C = i ? Symbol.for("react.portal") : 60106, a = i ? Symbol.for("react.fragment") : 60107, S = i ? Symbol.for("react.strict_mode") : 60108, u = i ? Symbol.for("react.profiler") : 60114, w = i ? Symbol.for("react.provider") : 60109, l = i ? Symbol.for("react.context") : 60110, A = i ? Symbol.for("react.async_mode") : 60111, O = i ? Symbol.for("react.concurrent_mode") : 60111, v = i ? Symbol.for("react.forward_ref") : 60112, g = i ? Symbol.for("react.suspense") : 60113, z = i ? Symbol.for("react.suspense_list") : 60120, U = i ? Symbol.for("react.memo") : 60115, M = i ? Symbol.for("react.lazy") : 60116, j = i ? Symbol.for("react.block") : 60121, D = i ? Symbol.for("react.fundamental") : 60117, Y = i ? Symbol.for("react.responder") : 60118, J = i ? Symbol.for("react.scope") : 60119;
  function H(e) {
    if (typeof e == "object" && e !== null) {
      var s = e.$$typeof;
      switch (s) {
        case $:
          switch (e = e.type, e) {
            case A:
            case O:
            case a:
            case u:
            case S:
            case g:
              return e;
            default:
              switch (e = e && e.$$typeof, e) {
                case l:
                case v:
                case M:
                case U:
                case w:
                  return e;
                default:
                  return s;
              }
          }
        case C:
          return s;
      }
    }
  }
  function W(e) {
    return H(e) === O;
  }
  return E.AsyncMode = A, E.ConcurrentMode = O, E.ContextConsumer = l, E.ContextProvider = w, E.Element = $, E.ForwardRef = v, E.Fragment = a, E.Lazy = M, E.Memo = U, E.Portal = C, E.Profiler = u, E.StrictMode = S, E.Suspense = g, E.isAsyncMode = function(e) {
    return W(e) || H(e) === A;
  }, E.isConcurrentMode = W, E.isContextConsumer = function(e) {
    return H(e) === l;
  }, E.isContextProvider = function(e) {
    return H(e) === w;
  }, E.isElement = function(e) {
    return typeof e == "object" && e !== null && e.$$typeof === $;
  }, E.isForwardRef = function(e) {
    return H(e) === v;
  }, E.isFragment = function(e) {
    return H(e) === a;
  }, E.isLazy = function(e) {
    return H(e) === M;
  }, E.isMemo = function(e) {
    return H(e) === U;
  }, E.isPortal = function(e) {
    return H(e) === C;
  }, E.isProfiler = function(e) {
    return H(e) === u;
  }, E.isStrictMode = function(e) {
    return H(e) === S;
  }, E.isSuspense = function(e) {
    return H(e) === g;
  }, E.isValidElementType = function(e) {
    return typeof e == "string" || typeof e == "function" || e === a || e === O || e === u || e === S || e === g || e === z || typeof e == "object" && e !== null && (e.$$typeof === M || e.$$typeof === U || e.$$typeof === w || e.$$typeof === l || e.$$typeof === v || e.$$typeof === D || e.$$typeof === Y || e.$$typeof === J || e.$$typeof === j);
  }, E.typeOf = H, E;
}
var _ = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ce;
function Oe() {
  return ce || (ce = 1, process.env.NODE_ENV !== "production" && function() {
    var i = typeof Symbol == "function" && Symbol.for, $ = i ? Symbol.for("react.element") : 60103, C = i ? Symbol.for("react.portal") : 60106, a = i ? Symbol.for("react.fragment") : 60107, S = i ? Symbol.for("react.strict_mode") : 60108, u = i ? Symbol.for("react.profiler") : 60114, w = i ? Symbol.for("react.provider") : 60109, l = i ? Symbol.for("react.context") : 60110, A = i ? Symbol.for("react.async_mode") : 60111, O = i ? Symbol.for("react.concurrent_mode") : 60111, v = i ? Symbol.for("react.forward_ref") : 60112, g = i ? Symbol.for("react.suspense") : 60113, z = i ? Symbol.for("react.suspense_list") : 60120, U = i ? Symbol.for("react.memo") : 60115, M = i ? Symbol.for("react.lazy") : 60116, j = i ? Symbol.for("react.block") : 60121, D = i ? Symbol.for("react.fundamental") : 60117, Y = i ? Symbol.for("react.responder") : 60118, J = i ? Symbol.for("react.scope") : 60119;
    function H(n) {
      return typeof n == "string" || typeof n == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      n === a || n === O || n === u || n === S || n === g || n === z || typeof n == "object" && n !== null && (n.$$typeof === M || n.$$typeof === U || n.$$typeof === w || n.$$typeof === l || n.$$typeof === v || n.$$typeof === D || n.$$typeof === Y || n.$$typeof === J || n.$$typeof === j);
    }
    function W(n) {
      if (typeof n == "object" && n !== null) {
        var V = n.$$typeof;
        switch (V) {
          case $:
            var K = n.type;
            switch (K) {
              case A:
              case O:
              case a:
              case u:
              case S:
              case g:
                return K;
              default:
                var ue = K && K.$$typeof;
                switch (ue) {
                  case l:
                  case v:
                  case M:
                  case U:
                  case w:
                    return ue;
                  default:
                    return V;
                }
            }
          case C:
            return V;
        }
      }
    }
    var e = A, s = O, I = l, x = w, q = $, T = v, t = a, k = M, L = U, R = C, F = u, B = S, G = g, X = !1;
    function Q(n) {
      return X || (X = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), r(n) || W(n) === A;
    }
    function r(n) {
      return W(n) === O;
    }
    function o(n) {
      return W(n) === l;
    }
    function y(n) {
      return W(n) === w;
    }
    function d(n) {
      return typeof n == "object" && n !== null && n.$$typeof === $;
    }
    function f(n) {
      return W(n) === v;
    }
    function h(n) {
      return W(n) === a;
    }
    function c(n) {
      return W(n) === M;
    }
    function p(n) {
      return W(n) === U;
    }
    function m(n) {
      return W(n) === C;
    }
    function P(n) {
      return W(n) === u;
    }
    function b(n) {
      return W(n) === S;
    }
    function N(n) {
      return W(n) === g;
    }
    _.AsyncMode = e, _.ConcurrentMode = s, _.ContextConsumer = I, _.ContextProvider = x, _.Element = q, _.ForwardRef = T, _.Fragment = t, _.Lazy = k, _.Memo = L, _.Portal = R, _.Profiler = F, _.StrictMode = B, _.Suspense = G, _.isAsyncMode = Q, _.isConcurrentMode = r, _.isContextConsumer = o, _.isContextProvider = y, _.isElement = d, _.isForwardRef = f, _.isFragment = h, _.isLazy = c, _.isMemo = p, _.isPortal = m, _.isProfiler = P, _.isStrictMode = b, _.isSuspense = N, _.isValidElementType = H, _.typeOf = W;
  }()), _;
}
var le;
function ge() {
  return le || (le = 1, process.env.NODE_ENV === "production" ? Z.exports = Pe() : Z.exports = Oe()), Z.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ee, de;
function Re() {
  if (de) return ee;
  de = 1;
  var i = Object.getOwnPropertySymbols, $ = Object.prototype.hasOwnProperty, C = Object.prototype.propertyIsEnumerable;
  function a(u) {
    if (u == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(u);
  }
  function S() {
    try {
      if (!Object.assign)
        return !1;
      var u = new String("abc");
      if (u[5] = "de", Object.getOwnPropertyNames(u)[0] === "5")
        return !1;
      for (var w = {}, l = 0; l < 10; l++)
        w["_" + String.fromCharCode(l)] = l;
      var A = Object.getOwnPropertyNames(w).map(function(v) {
        return w[v];
      });
      if (A.join("") !== "0123456789")
        return !1;
      var O = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(v) {
        O[v] = v;
      }), Object.keys(Object.assign({}, O)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ee = S() ? Object.assign : function(u, w) {
    for (var l, A = a(u), O, v = 1; v < arguments.length; v++) {
      l = Object(arguments[v]);
      for (var g in l)
        $.call(l, g) && (A[g] = l[g]);
      if (i) {
        O = i(l);
        for (var z = 0; z < O.length; z++)
          C.call(l, O[z]) && (A[O[z]] = l[O[z]]);
      }
    }
    return A;
  }, ee;
}
var re, pe;
function se() {
  if (pe) return re;
  pe = 1;
  var i = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return re = i, re;
}
var te, ye;
function Ee() {
  return ye || (ye = 1, te = Function.call.bind(Object.prototype.hasOwnProperty)), te;
}
var ne, ve;
function Se() {
  if (ve) return ne;
  ve = 1;
  var i = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var $ = se(), C = {}, a = Ee();
    i = function(u) {
      var w = "Warning: " + u;
      typeof console < "u" && console.error(w);
      try {
        throw new Error(w);
      } catch {
      }
    };
  }
  function S(u, w, l, A, O) {
    if (process.env.NODE_ENV !== "production") {
      for (var v in u)
        if (a(u, v)) {
          var g;
          try {
            if (typeof u[v] != "function") {
              var z = Error(
                (A || "React class") + ": " + l + " type `" + v + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof u[v] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw z.name = "Invariant Violation", z;
            }
            g = u[v](w, v, A, l, null, $);
          } catch (M) {
            g = M;
          }
          if (g && !(g instanceof Error) && i(
            (A || "React class") + ": type specification of " + l + " `" + v + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof g + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), g instanceof Error && !(g.message in C)) {
            C[g.message] = !0;
            var U = O ? O() : "";
            i(
              "Failed " + l + " type: " + g.message + (U ?? "")
            );
          }
        }
    }
  }
  return S.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (C = {});
  }, ne = S, ne;
}
var oe, he;
function we() {
  if (he) return oe;
  he = 1;
  var i = ge(), $ = Re(), C = se(), a = Ee(), S = Se(), u = function() {
  };
  process.env.NODE_ENV !== "production" && (u = function(l) {
    var A = "Warning: " + l;
    typeof console < "u" && console.error(A);
    try {
      throw new Error(A);
    } catch {
    }
  });
  function w() {
    return null;
  }
  return oe = function(l, A) {
    var O = typeof Symbol == "function" && Symbol.iterator, v = "@@iterator";
    function g(r) {
      var o = r && (O && r[O] || r[v]);
      if (typeof o == "function")
        return o;
    }
    var z = "<<anonymous>>", U = {
      array: Y("array"),
      bigint: Y("bigint"),
      bool: Y("boolean"),
      func: Y("function"),
      number: Y("number"),
      object: Y("object"),
      string: Y("string"),
      symbol: Y("symbol"),
      any: J(),
      arrayOf: H,
      element: W(),
      elementType: e(),
      instanceOf: s,
      node: T(),
      objectOf: x,
      oneOf: I,
      oneOfType: q,
      shape: k,
      exact: L
    };
    function M(r, o) {
      return r === o ? r !== 0 || 1 / r === 1 / o : r !== r && o !== o;
    }
    function j(r, o) {
      this.message = r, this.data = o && typeof o == "object" ? o : {}, this.stack = "";
    }
    j.prototype = Error.prototype;
    function D(r) {
      if (process.env.NODE_ENV !== "production")
        var o = {}, y = 0;
      function d(h, c, p, m, P, b, N) {
        if (m = m || z, b = b || p, N !== C) {
          if (A) {
            var n = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw n.name = "Invariant Violation", n;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var V = m + ":" + p;
            !o[V] && // Avoid spamming the console because they are often not actionable except for lib authors
            y < 3 && (u(
              "You are manually calling a React.PropTypes validation function for the `" + b + "` prop on `" + m + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), o[V] = !0, y++);
          }
        }
        return c[p] == null ? h ? c[p] === null ? new j("The " + P + " `" + b + "` is marked as required " + ("in `" + m + "`, but its value is `null`.")) : new j("The " + P + " `" + b + "` is marked as required in " + ("`" + m + "`, but its value is `undefined`.")) : null : r(c, p, m, P, b);
      }
      var f = d.bind(null, !1);
      return f.isRequired = d.bind(null, !0), f;
    }
    function Y(r) {
      function o(y, d, f, h, c, p) {
        var m = y[d], P = B(m);
        if (P !== r) {
          var b = G(m);
          return new j(
            "Invalid " + h + " `" + c + "` of type " + ("`" + b + "` supplied to `" + f + "`, expected ") + ("`" + r + "`."),
            { expectedType: r }
          );
        }
        return null;
      }
      return D(o);
    }
    function J() {
      return D(w);
    }
    function H(r) {
      function o(y, d, f, h, c) {
        if (typeof r != "function")
          return new j("Property `" + c + "` of component `" + f + "` has invalid PropType notation inside arrayOf.");
        var p = y[d];
        if (!Array.isArray(p)) {
          var m = B(p);
          return new j("Invalid " + h + " `" + c + "` of type " + ("`" + m + "` supplied to `" + f + "`, expected an array."));
        }
        for (var P = 0; P < p.length; P++) {
          var b = r(p, P, f, h, c + "[" + P + "]", C);
          if (b instanceof Error)
            return b;
        }
        return null;
      }
      return D(o);
    }
    function W() {
      function r(o, y, d, f, h) {
        var c = o[y];
        if (!l(c)) {
          var p = B(c);
          return new j("Invalid " + f + " `" + h + "` of type " + ("`" + p + "` supplied to `" + d + "`, expected a single ReactElement."));
        }
        return null;
      }
      return D(r);
    }
    function e() {
      function r(o, y, d, f, h) {
        var c = o[y];
        if (!i.isValidElementType(c)) {
          var p = B(c);
          return new j("Invalid " + f + " `" + h + "` of type " + ("`" + p + "` supplied to `" + d + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return D(r);
    }
    function s(r) {
      function o(y, d, f, h, c) {
        if (!(y[d] instanceof r)) {
          var p = r.name || z, m = Q(y[d]);
          return new j("Invalid " + h + " `" + c + "` of type " + ("`" + m + "` supplied to `" + f + "`, expected ") + ("instance of `" + p + "`."));
        }
        return null;
      }
      return D(o);
    }
    function I(r) {
      if (!Array.isArray(r))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? u(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : u("Invalid argument supplied to oneOf, expected an array.")), w;
      function o(y, d, f, h, c) {
        for (var p = y[d], m = 0; m < r.length; m++)
          if (M(p, r[m]))
            return null;
        var P = JSON.stringify(r, function(N, n) {
          var V = G(n);
          return V === "symbol" ? String(n) : n;
        });
        return new j("Invalid " + h + " `" + c + "` of value `" + String(p) + "` " + ("supplied to `" + f + "`, expected one of " + P + "."));
      }
      return D(o);
    }
    function x(r) {
      function o(y, d, f, h, c) {
        if (typeof r != "function")
          return new j("Property `" + c + "` of component `" + f + "` has invalid PropType notation inside objectOf.");
        var p = y[d], m = B(p);
        if (m !== "object")
          return new j("Invalid " + h + " `" + c + "` of type " + ("`" + m + "` supplied to `" + f + "`, expected an object."));
        for (var P in p)
          if (a(p, P)) {
            var b = r(p, P, f, h, c + "." + P, C);
            if (b instanceof Error)
              return b;
          }
        return null;
      }
      return D(o);
    }
    function q(r) {
      if (!Array.isArray(r))
        return process.env.NODE_ENV !== "production" && u("Invalid argument supplied to oneOfType, expected an instance of array."), w;
      for (var o = 0; o < r.length; o++) {
        var y = r[o];
        if (typeof y != "function")
          return u(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + X(y) + " at index " + o + "."
          ), w;
      }
      function d(f, h, c, p, m) {
        for (var P = [], b = 0; b < r.length; b++) {
          var N = r[b], n = N(f, h, c, p, m, C);
          if (n == null)
            return null;
          n.data && a(n.data, "expectedType") && P.push(n.data.expectedType);
        }
        var V = P.length > 0 ? ", expected one of type [" + P.join(", ") + "]" : "";
        return new j("Invalid " + p + " `" + m + "` supplied to " + ("`" + c + "`" + V + "."));
      }
      return D(d);
    }
    function T() {
      function r(o, y, d, f, h) {
        return R(o[y]) ? null : new j("Invalid " + f + " `" + h + "` supplied to " + ("`" + d + "`, expected a ReactNode."));
      }
      return D(r);
    }
    function t(r, o, y, d, f) {
      return new j(
        (r || "React class") + ": " + o + " type `" + y + "." + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + f + "`."
      );
    }
    function k(r) {
      function o(y, d, f, h, c) {
        var p = y[d], m = B(p);
        if (m !== "object")
          return new j("Invalid " + h + " `" + c + "` of type `" + m + "` " + ("supplied to `" + f + "`, expected `object`."));
        for (var P in r) {
          var b = r[P];
          if (typeof b != "function")
            return t(f, h, c, P, G(b));
          var N = b(p, P, f, h, c + "." + P, C);
          if (N)
            return N;
        }
        return null;
      }
      return D(o);
    }
    function L(r) {
      function o(y, d, f, h, c) {
        var p = y[d], m = B(p);
        if (m !== "object")
          return new j("Invalid " + h + " `" + c + "` of type `" + m + "` " + ("supplied to `" + f + "`, expected `object`."));
        var P = $({}, y[d], r);
        for (var b in P) {
          var N = r[b];
          if (a(r, b) && typeof N != "function")
            return t(f, h, c, b, G(N));
          if (!N)
            return new j(
              "Invalid " + h + " `" + c + "` key `" + b + "` supplied to `" + f + "`.\nBad object: " + JSON.stringify(y[d], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(r), null, "  ")
            );
          var n = N(p, b, f, h, c + "." + b, C);
          if (n)
            return n;
        }
        return null;
      }
      return D(o);
    }
    function R(r) {
      switch (typeof r) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !r;
        case "object":
          if (Array.isArray(r))
            return r.every(R);
          if (r === null || l(r))
            return !0;
          var o = g(r);
          if (o) {
            var y = o.call(r), d;
            if (o !== r.entries) {
              for (; !(d = y.next()).done; )
                if (!R(d.value))
                  return !1;
            } else
              for (; !(d = y.next()).done; ) {
                var f = d.value;
                if (f && !R(f[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function F(r, o) {
      return r === "symbol" ? !0 : o ? o["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && o instanceof Symbol : !1;
    }
    function B(r) {
      var o = typeof r;
      return Array.isArray(r) ? "array" : r instanceof RegExp ? "object" : F(o, r) ? "symbol" : o;
    }
    function G(r) {
      if (typeof r > "u" || r === null)
        return "" + r;
      var o = B(r);
      if (o === "object") {
        if (r instanceof Date)
          return "date";
        if (r instanceof RegExp)
          return "regexp";
      }
      return o;
    }
    function X(r) {
      var o = G(r);
      switch (o) {
        case "array":
        case "object":
          return "an " + o;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + o;
        default:
          return o;
      }
    }
    function Q(r) {
      return !r.constructor || !r.constructor.name ? z : r.constructor.name;
    }
    return U.checkPropTypes = S, U.resetWarningCache = S.resetWarningCache, U.PropTypes = U, U;
  }, oe;
}
var ie, me;
function Ce() {
  if (me) return ie;
  me = 1;
  var i = se();
  function $() {
  }
  function C() {
  }
  return C.resetWarningCache = $, ie = function() {
    function a(w, l, A, O, v, g) {
      if (g !== i) {
        var z = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw z.name = "Invariant Violation", z;
      }
    }
    a.isRequired = a;
    function S() {
      return a;
    }
    var u = {
      array: a,
      bigint: a,
      bool: a,
      func: a,
      number: a,
      object: a,
      string: a,
      symbol: a,
      any: a,
      arrayOf: S,
      element: a,
      elementType: a,
      instanceOf: S,
      node: a,
      objectOf: S,
      oneOf: S,
      oneOfType: S,
      shape: S,
      exact: S,
      checkPropTypes: C,
      resetWarningCache: $
    };
    return u.PropTypes = u, u;
  }, ie;
}
if (process.env.NODE_ENV !== "production") {
  var xe = ge(), Ae = !0;
  ae.exports = we()(xe.isElement, Ae);
} else
  ae.exports = Ce()();
var Ie = ae.exports;
(function(i) {
  function $(e) {
    "@babel/helpers - typeof";
    return $ = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
      return typeof s;
    } : function(s) {
      return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
    }, $(e);
  }
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), i.default = W;
  var C = w(_e), a = S(Ie);
  function S(e) {
    return e && e.__esModule ? e : { default: e };
  }
  function u(e) {
    if (typeof WeakMap != "function") return null;
    var s = /* @__PURE__ */ new WeakMap(), I = /* @__PURE__ */ new WeakMap();
    return (u = function(q) {
      return q ? I : s;
    })(e);
  }
  function w(e, s) {
    if (e && e.__esModule)
      return e;
    if (e === null || $(e) !== "object" && typeof e != "function")
      return { default: e };
    var I = u(s);
    if (I && I.has(e))
      return I.get(e);
    var x = {}, q = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var T in e)
      if (T !== "default" && Object.prototype.hasOwnProperty.call(e, T)) {
        var t = q ? Object.getOwnPropertyDescriptor(e, T) : null;
        t && (t.get || t.set) ? Object.defineProperty(x, T, t) : x[T] = e[T];
      }
    return x.default = e, I && I.set(e, x), x;
  }
  function l(e, s) {
    if (!(e instanceof s))
      throw new TypeError("Cannot call a class as a function");
  }
  function A(e, s) {
    for (var I = 0; I < s.length; I++) {
      var x = s[I];
      x.enumerable = x.enumerable || !1, x.configurable = !0, "value" in x && (x.writable = !0), Object.defineProperty(e, x.key, x);
    }
  }
  function O(e, s, I) {
    return s && A(e.prototype, s), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function v(e, s) {
    if (typeof s != "function" && s !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(s && s.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), s && g(e, s);
  }
  function g(e, s) {
    return g = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(x, q) {
      return x.__proto__ = q, x;
    }, g(e, s);
  }
  function z(e) {
    var s = j();
    return function() {
      var x = D(e), q;
      if (s) {
        var T = D(this).constructor;
        q = Reflect.construct(x, arguments, T);
      } else
        q = x.apply(this, arguments);
      return U(this, q);
    };
  }
  function U(e, s) {
    if (s && ($(s) === "object" || typeof s == "function"))
      return s;
    if (s !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return M(e);
  }
  function M(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function j() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function D(e) {
    return D = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(I) {
      return I.__proto__ || Object.getPrototypeOf(I);
    }, D(e);
  }
  var Y = ["AfterExport", "AfterPlot", "Animated", "AnimatingFrame", "AnimationInterrupted", "AutoSize", "BeforeExport", "BeforeHover", "ButtonClicked", "Click", "ClickAnnotation", "Deselect", "DoubleClick", "Framework", "Hover", "LegendClick", "LegendDoubleClick", "Relayout", "Relayouting", "Restyle", "Redraw", "Selected", "Selecting", "SliderChange", "SliderEnd", "SliderStart", "SunburstClick", "Transitioning", "TransitionInterrupted", "Unhover", "WebGlContextLost"], J = ["plotly_restyle", "plotly_redraw", "plotly_relayout", "plotly_relayouting", "plotly_doubleclick", "plotly_animated", "plotly_sunburstclick"], H = typeof window < "u";
  function W(e) {
    var s = /* @__PURE__ */ function(I) {
      v(q, I);
      var x = z(q);
      function q(T) {
        var t;
        return l(this, q), t = x.call(this, T), t.p = Promise.resolve(), t.resizeHandler = null, t.handlers = {}, t.syncWindowResize = t.syncWindowResize.bind(M(t)), t.syncEventHandlers = t.syncEventHandlers.bind(M(t)), t.attachUpdateEvents = t.attachUpdateEvents.bind(M(t)), t.getRef = t.getRef.bind(M(t)), t.handleUpdate = t.handleUpdate.bind(M(t)), t.figureCallback = t.figureCallback.bind(M(t)), t.updatePlotly = t.updatePlotly.bind(M(t)), t;
      }
      return O(q, [{
        key: "updatePlotly",
        value: function(t, k, L) {
          var R = this;
          this.p = this.p.then(function() {
            if (!R.unmounting) {
              if (!R.el)
                throw new Error("Missing element reference");
              return e.react(R.el, {
                data: R.props.data,
                layout: R.props.layout,
                config: R.props.config,
                frames: R.props.frames
              });
            }
          }).then(function() {
            R.unmounting || (R.syncWindowResize(t), R.syncEventHandlers(), R.figureCallback(k), L && R.attachUpdateEvents());
          }).catch(function(F) {
            R.props.onError && R.props.onError(F);
          });
        }
      }, {
        key: "componentDidMount",
        value: function() {
          this.unmounting = !1, this.updatePlotly(!0, this.props.onInitialized, !0);
        }
      }, {
        key: "componentDidUpdate",
        value: function(t) {
          this.unmounting = !1;
          var k = t.frames && t.frames.length ? t.frames.length : 0, L = this.props.frames && this.props.frames.length ? this.props.frames.length : 0, R = !(t.layout === this.props.layout && t.data === this.props.data && t.config === this.props.config && L === k), F = t.revision !== void 0, B = t.revision !== this.props.revision;
          !R && (!F || F && !B) || this.updatePlotly(!1, this.props.onUpdate, !1);
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          this.unmounting = !0, this.figureCallback(this.props.onPurge), this.resizeHandler && H && (window.removeEventListener("resize", this.resizeHandler), this.resizeHandler = null), this.removeUpdateEvents(), e.purge(this.el);
        }
      }, {
        key: "attachUpdateEvents",
        value: function() {
          var t = this;
          !this.el || !this.el.removeListener || J.forEach(function(k) {
            t.el.on(k, t.handleUpdate);
          });
        }
      }, {
        key: "removeUpdateEvents",
        value: function() {
          var t = this;
          !this.el || !this.el.removeListener || J.forEach(function(k) {
            t.el.removeListener(k, t.handleUpdate);
          });
        }
      }, {
        key: "handleUpdate",
        value: function() {
          this.figureCallback(this.props.onUpdate);
        }
      }, {
        key: "figureCallback",
        value: function(t) {
          if (typeof t == "function") {
            var k = this.el, L = k.data, R = k.layout, F = this.el._transitionData ? this.el._transitionData._frames : null, B = {
              data: L,
              layout: R,
              frames: F
            };
            t(B, this.el);
          }
        }
      }, {
        key: "syncWindowResize",
        value: function(t) {
          var k = this;
          H && (this.props.useResizeHandler && !this.resizeHandler ? (this.resizeHandler = function() {
            return e.Plots.resize(k.el);
          }, window.addEventListener("resize", this.resizeHandler), t && this.resizeHandler()) : !this.props.useResizeHandler && this.resizeHandler && (window.removeEventListener("resize", this.resizeHandler), this.resizeHandler = null));
        }
      }, {
        key: "getRef",
        value: function(t) {
          this.el = t, this.props.debug && H && (window.gd = this.el);
        }
        // Attach and remove event handlers as they're added or removed from props:
      }, {
        key: "syncEventHandlers",
        value: function() {
          var t = this;
          Y.forEach(function(k) {
            var L = t.props["on" + k], R = t.handlers[k], F = !!R;
            L && !F ? t.addEventHandler(k, L) : !L && F ? t.removeEventHandler(k) : L && F && L !== R && (t.removeEventHandler(k), t.addEventHandler(k, L));
          });
        }
      }, {
        key: "addEventHandler",
        value: function(t, k) {
          this.handlers[t] = k, this.el.on(this.getPlotlyEventName(t), this.handlers[t]);
        }
      }, {
        key: "removeEventHandler",
        value: function(t) {
          this.el.removeListener(this.getPlotlyEventName(t), this.handlers[t]), delete this.handlers[t];
        }
      }, {
        key: "getPlotlyEventName",
        value: function(t) {
          return "plotly_" + t.toLowerCase();
        }
      }, {
        key: "render",
        value: function() {
          return /* @__PURE__ */ C.default.createElement("div", {
            id: this.props.divId,
            style: this.props.style,
            ref: this.getRef,
            className: this.props.className
          });
        }
      }]), q;
    }(C.Component);
    return s.propTypes = {
      data: a.default.arrayOf(a.default.object),
      config: a.default.object,
      layout: a.default.object,
      frames: a.default.arrayOf(a.default.object),
      revision: a.default.number,
      onInitialized: a.default.func,
      onPurge: a.default.func,
      onError: a.default.func,
      onUpdate: a.default.func,
      debug: a.default.bool,
      style: a.default.object,
      className: a.default.string,
      useResizeHandler: a.default.bool,
      divId: a.default.string
    }, Y.forEach(function(I) {
      s.propTypes["on" + I] = a.default.func;
    }), s.defaultProps = {
      debug: !1,
      useResizeHandler: !1,
      data: [],
      style: {
        position: "relative",
        display: "inline-block"
      }
    }, s;
  }
})(be);
const Me = /* @__PURE__ */ Te(be);
export {
  Me as c
};
//# sourceMappingURL=react-plotly.js-b7Wmpgy5.js.map
